import {
    Card,
    CardContent,
    Grid,
    Box,
    Button,
    CircularProgress,
} from "@mui/material";
import Tabs from "../../branchDepartment/components/tabs";
import { useState, useEffect } from "react";
import SnackbarMessage from "../../../components/snackBar/snackBar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { APP_ROUTES } from "../../../config/appRoutes";
import { getOrganizationsThunk, addOrganizationThunk } from "../../contact/contactThunk";
import { FieldTextField } from "../../../components/selections/fieldInputs";
import { stepCardSx, stepActionsSx, nextBtnSx, backBtnSx, StepHeader } from "../../campaign/components/stepUi";
import { Stack } from "@mui/material";
import DomainAddOutlinedIcon from "@mui/icons-material/DomainAddOutlined";
import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";

// Create-organization form. `embedded` = inside the list page popup (no page header, Cancel button,
// onSuccess(message) closes the popup and the list shows the message).
export function OrganizationCreateForm({ embedded = false, onCancel, onSuccess }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { status, error } = useSelector((state) => state.contacts);


    const [organizationName, setOrganizationName] = useState("");
    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "success",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!organizationName.trim()) {
            setSnackbar({
                open: true,
                message: "Organization Name is required",
                severity: "error",
            });
            return;
        }

        try {
             const result = await dispatch(
                addOrganizationThunk({ credentials: { organization_name: organizationName.trim() } }) // also trim before submit
            );

            if (result.meta.requestStatus === "fulfilled") {
                if (onSuccess) {
                    dispatch(getOrganizationsThunk({ type: "getOrganizations" }));
                    onSuccess(result.payload?.message);
                    return;
                }
                setSnackbar({
                    open: true,
                    message: result.payload.message,
                    severity: "success",
                });
                dispatch(getOrganizationsThunk({ type: "getOrganizations" }));

                navigate(APP_ROUTES.ORGANIZATION.LIST);
            } else {
                setSnackbar({
                    open: true,
                    message: result.payload,
                    severity: "error",
                });
            }
        } catch {
            setSnackbar({
                open: true,
                message: "Server error. Please try again.",
                severity: "error",
            });
        }
    };

    useEffect(() => {
        if (error !== null) {
            setSnackbar({
                open: true,
                message: error,
                severity: "error",
            });
        }
    }, [error]);

    const Wrap = embedded ? Box : Tabs;

    return (
        <div>
            <Wrap>
                <Box mt={embedded ? 0 : 1}>
                    <Card elevation={0} sx={embedded ? { borderRadius: 0, boxShadow: "none" } : stepCardSx}>
                        <CardContent sx={{ p: { xs: 2, sm: 3 } }}>
                            {!embedded && (
                                <StepHeader
                                    icon={<DomainAddOutlinedIcon sx={{ fontSize: 20 }} />}
                                    title="Create Organization"
                                    subtitle="Add a new organization to group your contacts"
                                />
                            )}
                            <Grid container spacing={2}>
                                <Grid item size={embedded ? { xs: 12 } : { xs: 12, sm: 8, md: 5 }}>
                                    <FieldTextField
                                        name="organizationName"
                                        label="Organization Name"
                                        placeholder="Enter organization name"
                                        required
                                        icon={<ApartmentRoundedIcon />}
                                        value={organizationName}
                                        maxLength={20}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            // prevent initial space
                                            if (value.startsWith(" ")) return;
                                            setOrganizationName(value);
                                        }}
                                        error={!organizationName.trim() && snackbar.severity === "error"}
                                    />
                                </Grid>
                            </Grid>
                        </CardContent>

                        {/* Footer actions */}
                        <Box sx={stepActionsSx}>
                            <Stack direction="row" spacing={1.5}>
                            {embedded && (
                                <Button onClick={onCancel} sx={backBtnSx}>Cancel</Button>
                            )}
                            <Button
                                disabled={status === "loading"}
                                onClick={status === "loading" ? null : handleSubmit}
                                startIcon={status === "loading" ? <CircularProgress size={16} sx={{ color: "#fff" }} /> : <AddCircleOutlineIcon />}
                                sx={nextBtnSx}
                            >
                                {status === "loading" ? "Submitting.." : "Create Organization"}
                            </Button>
                            </Stack>
                        </Box>
                    </Card>
                </Box>
            </Wrap>

            <SnackbarMessage
                open={snackbar.open}
                message={snackbar.message}
                severity={snackbar.severity}
                onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
            />
        </div>
    );
}

// /organization-creation page
export default function BranchCreation() {
    return <OrganizationCreateForm />;
}
